import {useInfiniteMailFolders} from "@twigsby/client-data";
import {ComboBoxControl, SelectItemType} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useEffect, useState} from "react";

type InFolderConditionType = {
    name: string;
    defaultValue: any;
    changeCallback: (value: any) => void;
}

const InFolderCondition = (props: InFolderConditionType) => {
    const { control} = useFormContext();

    const { data, status } = useInfiniteMailFolders();
    const [ folderOptions, setFolderOptions ] = useState<Array<SelectItemType>>([]);

    const IterateData = () => {
        let NewFolderOptions: Array<SelectItemType> = [];

        data?.pages.forEach((page) =>
            page?.data && page.data.filter((folder, index: number) =>
                folder ? NewFolderOptions.push({'label': folder.name, 'value': folder.id}) : null
            )
        );

        setFolderOptions(NewFolderOptions);
    }

    useEffect(() => {
        if(data) {
            IterateData();
        }
    }, [data]);

    return (
        <Controller
            control={control}
            name={props.name}
            defaultValue={props.defaultValue}
            rules={{ required: "Folders is required" }}
            render={({ field, fieldState }) =>
                <ComboBoxControl
                    data={folderOptions}
                    defaultValues={field.value}
                    forwardValuesCallback={(val) => {
                        field.onChange(val)
                    }}
                    name={field.name}
                    placeholder={'Select Folders...'}
                    loading={status === 'loading'}
                    disabled={status === 'error'}
                    valueType={'number'}
                />
            }
        />
    )
}

export { InFolderCondition }
